import React from 'react';

const NoPermissions = () => {
  return (
    <div className='NotFound'>
      <h3>Sorry, you do not have permissions set up for your account!</h3>
    </div>
  );
};

export default NoPermissions;
